import * as React from 'react';
import { DatePickerComponentContainer, DatePickerContainer, DatePickerTitle, YearPicker, MonthPicker, DayPicker, AlertText } from './styles';
import { SearchableDropdownItem } from 'components/SearchableDropdown/constants';
import _ from 'lodash';
import { DrawerContainer, DrawerList, DrawerOptionsContainer, MainContainer } from './styles';
import { FilterSuggestDrawerItem } from 'components/SearchableDropdown/SearchableDropdownItem';
import { Months, Days } from './constants';
import { getDate, getDaysInMonth, getMonth, getYear } from 'date-fns';
import { parseStringDateToDateObject } from 'features/Dealers/Listings/Data/state/utils';


export interface DatePickerStateProps {
    value?: string
    onChange: (value: string) => void;
}

export interface DatePickerActionProps {
}

declare type DatePickerProps = React.PropsWithChildren<DatePickerStateProps & DatePickerActionProps>

export const DatePicker = (props: DatePickerProps) => {
    let initialYear, intialMonth, initialDay;
    let initialDaysInMonth = -1
    if (props.value && !_.isEmpty(props.value)) {

        const date = parseStringDateToDateObject(props.value);
        const year = getYear(date);
        const month = getMonth(date);
        const day = getDate(date);

        initialDaysInMonth = getDaysInMonth(date)
        const montDsPn = _.find(Months, { id: `${month > 9 ? month : `0${month}`}` });
        initialYear = ({ id: `${year}`, displayName: `${year}` })
        intialMonth = ({ id: `${month}`, displayName: `${montDsPn?.displayName}` })
        initialDay = ({ id: `${day}`, displayName: `${day}` })
    }

    const [year, setYear] = React.useState<SearchableDropdownItem | undefined>(initialYear);
    const [month, setMonth] = React.useState<SearchableDropdownItem | undefined>(intialMonth);
    const [day, setDay] = React.useState<SearchableDropdownItem | undefined>(initialDay);
    const [showYears, setShowYears] = React.useState(false);
    const [showMonths, setShowMonths] = React.useState(false);
    const [showDays, setShowDays] = React.useState(false);
    const [focusedIndex, setFocusedIndex] = React.useState(-1);
    const [daysInMonth, setDaysInMonth] = React.useState(initialDaysInMonth);
    const [required, setRequired] = React.useState<boolean>(false);
    const [drawer, setDrawer] = React.useState<HTMLDivElement | null>(null)


    React.useEffect(() => {
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [drawer]);

    function handleClickOutside(event) {
        if (drawer && !drawer.contains(event.target)) {
            setShowYears(false)
            setShowMonths(false)
            setShowDays(false)
        }
    }

    React.useEffect(() => {
        if (year && month) {
            const date = new Date(parseInt(year.id), parseInt(month.id))
            const _daysInMonth = getDaysInMonth(date)
            if (day && parseInt(day.displayName) > _daysInMonth) {
                setDay({ id: '', displayName: '' })
            }
            setDaysInMonth(_daysInMonth)
            setRequired(false)
        }
    }, [year, month]);

    return (
        <DatePickerComponentContainer>

            <DatePickerContainer>
                <MainContainer>
                    <YearPicker
                        required={required}
                        placeholder={'Year'}
                        value={year?.displayName}
                        onChange={onYearInputChange}
                        readOnly={true}
                        onClick={() => { setShowYears(true); setShowDays(false); setShowMonths(false) }}
                    />
                    {
                        showYears && renderDrawer(_.range(getYear(new Date()), 1800, -1).map(r => ({ id: `${r}`, displayName: `${r}` })), onYearInputChange, (it: SearchableDropdownItem) => { return (true) })
                    }
                </MainContainer>
                <MainContainer>
                    <MonthPicker
                        required={required}
                        placeholder={'Month'}
                        value={month?.displayName}
                        onChange={onMonthInputChange}
                        onClick={() => { setShowYears(false); setShowDays(false); setShowMonths(true); }}
                        readOnly={true}
                    />
                    {
                        showMonths && renderDrawer(Months, onMonthInputChange, (it: SearchableDropdownItem) => { return (true) })
                    }
                </MainContainer>
                <MainContainer>
                    <DayPicker
                        placeholder={'Day'}
                        value={day?.displayName}
                        onChange={onDayInputChange}
                        onClick={showDaysDrawer}
                        readOnly={true}
                    />
                    {
                        showDays && renderDrawer(Days, onDayInputChange, (it: SearchableDropdownItem) => { return (parseInt(it.displayName) <= daysInMonth) })
                    }
                </MainContainer>
            </DatePickerContainer>
            {
                required &&
                <AlertText>
                    Year and month are required.
                </AlertText>
            }

        </DatePickerComponentContainer>
    )

    function renderDrawer(options: SearchableDropdownItem[], onSelect: (SearchableDropdownItem) => void, condition: (SearchableDropdownItem) => boolean) {
        return (
            <DrawerContainer>
                <DrawerOptionsContainer >
                    <DrawerList
                        ref={(node) => setDrawer(node as any)}
                    >
                        {
                            options.map((m, index) => {
                                if (condition(m)) {
                                    return (
                                        <FilterSuggestDrawerItem
                                            option={m}
                                            onOptionSelected={onSelect}
                                            focused={focusedIndex === index}
                                        />
                                    )
                                }
                            })

                        }
                    </DrawerList>
                </DrawerOptionsContainer>
            </DrawerContainer>
        )
    }

    function showDaysDrawer() {
        if (year && month) {
            setShowYears(false);
            setShowMonths(false)
            setShowDays(true)
        } else {
            setRequired(true)
        }
    }

    function onYearInputChange(e) {

        setYear(e);
        setShowYears(false)
        if (year && month) {
            setRequired(false)
        }
        if (e && month && day) {
            props.onChange(`${parseInt(e.id)}-${parseInt(month.id) + 1}-${parseInt(day.id)}`)
        }

    }

    function onMonthInputChange(e) {
        setMonth(e);
        setShowMonths(false)
        if (year && month) {
            setRequired(false)
        }
        if (year && e && day) {
            props.onChange(`${parseInt(year.id)}-${parseInt(e.id) + 1}-${parseInt(day.id)}`)
        }
    }

    function onDayInputChange(e) {
        setDay(e);
        setShowDays(false)
        if (year && month && e) {
            props.onChange(`${parseInt(year.id)}-${parseInt(month.id) + 1}-${parseInt(e.id)}`)
        }
    }


}